let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dQy5b")).then(() => parcelRequire('fcgkZ'));